<template>
    <div id="app" v-cloak>
        <router-view name="header" />
        <router-view />
        <router-view name="footer" />
        <el-backtop :visibility-height="100" :right="30" :bottom="100">
            <span class="toTop">
                <i class="el-icon-arrow-up"></i>
            </span>
        </el-backtop>
    </div>
</template>
<script>
export default {
    name: "app",
    data() {
        return {
           
        };
    },
    methods: {
    },
    created() {},
    mounted() {
        window.vmm = this;

    },
    destroyed() {},
    beforeDestroy() {},
};
</script>
<style lang="less">
#app {
    // font-family: "Microsoft YaHei";
    // font-family: "Microsoft YaHei" !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-user-select: none;
    -moz-user-select: none;
    overflow-x: none;
}

[v-cloak] {
    display: none;
}

.toTop {
    // position: fixed;
    // z-index: 9999;
    // right: 25px;
    // bottom:5rem;
    display: block;
    min-width: 50px;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 18px 0px rgba(220, 220, 220, 0.75);
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    color: #333333;
    font-size: 18px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(
        0,
        0,
        0,
        0
    ); /*CSS3去除手机浏览器按钮点击出现的高亮框*/
    -webkit-tap-highlight-color: transparent;
    -moz-tap-highlight-color: transparent;
}
</style>
